module.exports = __webpack_public_path__ + "static/media/img5.50151678.jpeg";